if (!customElements.get('wlsn-hearing-loss-tabs')) {
    class WLSNHearingLossTabs extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                classActive: 'is-active',
                classVisible: 'is-visible',
                tab: 'js-wlsn-hearing-loss-tab',
                panel: 'js-wlsn-hearing-loss-tab-content',
                stats: 'js-wlsn-hearing-loss-tab-num'
            };

            this.elements = {
                tabs: this.querySelectorAll(`.${this.classes.tab}`),
                panels: this.querySelectorAll(`.${this.classes.panel}`),
                stats: this.querySelectorAll(`.${this.classes.stats}`)
            };
        }

        connectedCallback() {
            this.initTabs();
            if (!this.elements.stats.length) return;
            this.initObserver();
        }

        initTabs() {
            if (!this.elements.tabs.length || !this.elements.panels.length) return;

            this.elements.tabs.forEach(tab => {
                tab.addEventListener('click', () => {
                    const index = tab.dataset.index;
                    this.activateTab(index);
                });
            });
        }

        activateTab(index) {
            this.elements.tabs.forEach(tab => {
                tab.classList.remove(this.classes.classActive);
            });

            this.elements.panels.forEach(panel => {
                panel.classList.remove(this.classes.classVisible);
            });

            this.elements.tabs[index]?.classList.add(this.classes.classActive);
            this.elements.panels[index]?.classList.add(this.classes.classVisible);
        }

        initObserver() {
            this.observer = new IntersectionObserver(
              (entries, observer) => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    this.animateNumbers();
                    observer.unobserve(entry.target);
                  }
                });
              },
              { threshold: 0.6 }
            );
      
            this.observer.observe(this);
          }

          animateNumbers() {
            this.elements.stats.forEach(el => {
              if (el.classList.contains('is-animated')) return;
              el.classList.add('is-animated');
      
              const rawValue = el.dataset.number;
              const target = parseFloat(rawValue);
              if (isNaN(target)) return;
      
              const decimals = (rawValue.split('.')[1] || '').length;
              const duration = target < 1 ? 800 : 1500;
              const start = performance.now();
      
              const animate = (now) => {
                const progress = Math.min((now - start) / duration, 1);
                const eased = 1 - Math.pow(1 - progress, 3);
                const value = eased * target;
      
                el.textContent = value.toFixed(decimals);
      
                if (progress < 1) {
                  requestAnimationFrame(animate);
                } else {
                  el.textContent = target.toFixed(decimals);
                }
              };
      
              requestAnimationFrame(animate);
            });
          }
    }

    customElements.define('wlsn-hearing-loss-tabs', WLSNHearingLossTabs);
}
